<template>
  <mdb-container>
    <section class="text-center my-5">
      <mdb-carousel :interval="8000" showControls showIndicators multi slide>
        <mdb-carousel-item>
          <mdb-row>
            <mdb-col md="4">
              <mdb-testimonial>
                <mdb-avatar class="mx-auto">
                  <img src="https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg" class="rounded-circle img-fluid"/>
                </mdb-avatar>
                <h4 class="font-weight-bold mt-4">Anna Deynah</h4>
                <h6 class="blue-text font-weight-bold my-3">Web Designer</h6>
                <p class="font-weight-normal"><mdb-icon icon="quote-left" class="pr-2"></mdb-icon>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod eos id officiis hic tenetur.</p>
                <div class="grey-text">
                  <mdb-icon icon="star"> </mdb-icon>
                  <mdb-icon icon="star"> </mdb-icon>
                  <mdb-icon icon="star"> </mdb-icon>
                  <mdb-icon icon="star"> </mdb-icon>
                  <mdb-icon icon="star-half-alt"> </mdb-icon>
                </div>
              </mdb-testimonial>
            </mdb-col>
            <mdb-col md="4" class="clearfix d-none d-md-block">
              <mdb-testimonial>
                <mdb-avatar class="mx-auto">
                  <img src="https://mdbootstrap.com/img/Photos/Avatars/img%20(3).jpg" class="rounded-circle img-fluid"/>
                </mdb-avatar>
                <h4 class="font-weight-bold mt-4">John Doe</h4>
                <h6 class="blue-text font-weight-bold my-3">Web Developer</h6>
                <p class="font-weight-normal"><mdb-icon icon="quote-left" class="pr-2"></mdb-icon>Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis laboriosam.</p>
                <div class="grey-text">
                  <mdb-icon icon="star"> </mdb-icon>
                  <mdb-icon icon="star"> </mdb-icon>
                  <mdb-icon icon="star"> </mdb-icon>
                  <mdb-icon icon="star"> </mdb-icon>
                  <mdb-icon icon="star"> </mdb-icon>
                </div>
              </mdb-testimonial>
            </mdb-col>
            
          
          </mdb-row>
        </mdb-carousel-item>
        <mdb-carousel-item>
          <mdb-row>
            
            <mdb-col md="4" class="clearfix d-none d-md-block">
              <mdb-testimonial>
                <mdb-avatar class="mx-auto">
                  <img src="https://mdbootstrap.com/img/Photos/Avatars/img%20(6).jpg" class="rounded-circle img-fluid"/>
                </mdb-avatar>
                <h4 class="font-weight-bold mt-4">Andrea Clay</h4>
                <h6 class="blue-text font-weight-bold my-3">Front-end developer</h6>
                <p class="font-weight-normal"><mdb-icon icon="quote-left" class="pr-2"></mdb-icon>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod eos id officiis hic tenetur quae.</p>
                <div class="grey-text">
                  <mdb-icon icon="star"> </mdb-icon>
                  <mdb-icon icon="star"> </mdb-icon>
                  <mdb-icon icon="star"> </mdb-icon>
                  <mdb-icon icon="star"> </mdb-icon>
                  <mdb-icon icon="star"> </mdb-icon>
                </div>
              </mdb-testimonial>
            </mdb-col>
            <mdb-col md="4" class="clearfix d-none d-md-block">
              <mdb-testimonial>
                <mdb-avatar class="mx-auto">
                  <img src="https://mdbootstrap.com/img/Photos/Avatars/img%20(7).jpg" class="rounded-circle img-fluid"/>
                </mdb-avatar>
                <h4 class="font-weight-bold mt-4">Cami Gosse</h4>
                <h6 class="blue-text font-weight-bold my-3">Phtographer</h6>
                <p class="font-weight-normal"><mdb-icon icon="quote-left" class="pr-2"></mdb-icon>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium.</p>
                <div class="grey-text">
                  <mdb-icon icon="star"> </mdb-icon>
                  <mdb-icon icon="star"> </mdb-icon>
                  <mdb-icon icon="star"> </mdb-icon>
                  <mdb-icon icon="star"> </mdb-icon>
                  <mdb-icon far icon="star"> </mdb-icon>
                </div>
              </mdb-testimonial>
            </mdb-col>
          
            <mdb-col md="4">
              <mdb-testimonial>
                <mdb-avatar class="mx-auto">
                  <img src="https://mdbootstrap.com/img/Photos/Avatars/img%20(8).jpg" class="rounded-circle img-fluid"/>
                </mdb-avatar>
                <h4 class="font-weight-bold mt-4">Bobby Haley</h4>
                <h6 class="blue-text font-weight-bold my-3">Web Developer</h6>
                <p class="font-weight-normal"><mdb-icon icon="quote-left" class="pr-2"></mdb-icon>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod eos id officiis hic tenetur quae.</p>
                <div class="grey-text">
                  <mdb-icon icon="star"> </mdb-icon>
                  <mdb-icon icon="star"> </mdb-icon>
                  <mdb-icon icon="star"> </mdb-icon>
                  <mdb-icon icon="star"> </mdb-icon>
                  <mdb-icon icon="star"> </mdb-icon>
                </div>
              </mdb-testimonial>
            </mdb-col>
            <mdb-col md="4" class="clearfix d-none d-md-block">
              <mdb-testimonial>
                <mdb-avatar class="mx-auto">
                  <img src="https://mdbootstrap.com/img/Photos/Avatars/img%20(10).jpg" class="rounded-circle img-fluid"/>
                </mdb-avatar>
                <h4 class="font-weight-bold mt-4">Elisa Janson</h4>
                <h6 class="blue-text font-weight-bold my-3">Marketer</h6>
                <p class="font-weight-normal"><mdb-icon icon="quote-left" class="pr-2"></mdb-icon>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium.</p>
                <div class="grey-text">
                  <mdb-icon icon="star"> </mdb-icon>
                  <mdb-icon icon="star"> </mdb-icon>
                  <mdb-icon icon="star"> </mdb-icon>
                  <mdb-icon icon="star"> </mdb-icon>
                  <mdb-icon icon="star-half-alt"> </mdb-icon>
                </div>
              </mdb-testimonial>
            </mdb-col>
            <mdb-col md="4" class="clearfix d-none d-md-block">
              <mdb-testimonial>
                <mdb-avatar class="mx-auto">
                  <img src="https://mdbootstrap.com/img/Photos/Avatars/img%20(9).jpg" class="rounded-circle img-fluid"/>
                </mdb-avatar>
                <h4 class="font-weight-bold mt-4">Rob Jacobs</h4>
                <h6 class="blue-text font-weight-bold my-3">Front-end developer</h6>
                <p class="font-weight-normal"><mdb-icon icon="quote-left" class="pr-2"></mdb-icon>Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis laboriosam.</p>
                <div class="grey-text">
                  <mdb-icon icon="star"> </mdb-icon>
                  <mdb-icon icon="star"> </mdb-icon>
                  <mdb-icon icon="star"> </mdb-icon>
                  <mdb-icon icon="star"> </mdb-icon>
                  <mdb-icon far icon="star"> </mdb-icon>
                </div>
              </mdb-testimonial>
            </mdb-col>
          </mdb-row>
        </mdb-carousel-item>
      </mdb-carousel>
    </section>
  </mdb-container>
</template>

<script>
	import {CONTENT_DOMAIN} from '@/constants/general_constants';
  import axios from 'axios';
  import {  mdbCard, mdbCardImage, mdbCardHeader, mdbCardBody, mdbCardTitle, mdbCardText, mdbCardFooter, mdbCardUp, mdbCardAvatar, mdbCardGroup, mdbBtn, mdbView, mdbMask, mdbIcon,mdbCarousel, mdbCarouselItem, mdbCarouselCaption, mdbContainer, mdbRow, mdbCol, mdbTestimonial, mdbAvatar } from 'mdbvue';
  export default {
		name: 'CardGroupFeatured',
		data() {
        return {
            interactive_block: [],
            CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN            
        };        
    },
    components: {
      mdbCard,
      mdbCardImage,
      mdbCardHeader,
      mdbCardBody,
      mdbCardTitle,
      mdbCardText,
      mdbCardFooter,
      mdbCardUp,
      mdbCardAvatar,
      mdbCardGroup,
      mdbBtn,
      mdbView,
      mdbMask,
      mdbIcon, mdbCarousel,
      mdbCarouselItem,
      mdbCarouselCaption,
      mdbContainer,
      mdbRow,
      mdbCol,
      mdbTestimonial,
      mdbAvatar,
      mdbIcon
		},
    mounted :function(){
        this.showInteractiveBlock()
		},
		methods:{
      showInteractiveBlock(){ 
          axios.get(this.$store.state.apiUrl+'/interactive_block',{
              params:{
                  id_language:this.$store.state.languageId,
                  id_company:this.$store.state.companyData['id_company']
                  
              }
          })
          .then(response => {
              response = response.data
              //console.log(response);
              this.interactive_block = response;
              this.$nextTick(function () {
                
              })
              
              //console.log(this.interactive_block)
          })
          .catch(() => {
              this.interactive_block = [];
          });
      }

    }
  }
</script>

<style scoped>
.btn-primary{
    background-color: #7f867917 !important;	
}

.view-img{
    display: inline-block !important;
}		
.card-footer {
    padding: 0 0 0 0;
    background-color:transparent;
    
}
.card{
	background-repeat: no-repeat;
  background-size: cover;
	
}
.back-light{
	background-color: rgba(0, 0, 0, 0.45);
}
</style>
